import React from 'react';

const ErrorCard = () => {
  return (
    <div className="user-card error">
      <div className="error-icon">⚠️</div>
      <div className="error-text">ОШИБКА</div>
    </div>
  );
};

export default ErrorCard;